import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  headerTitle: {
    color: theme.palette.gray.efesDarkGray,
    fontSize: 30,
    marginLeft: 10,
    marginBottom: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      marginLeft: 0,
      marginBottom: 20,
    },
  },
  insurance: {
    backgroundColor: theme.palette.white.efesBackgroundLight,
    display: 'flex',
    borderRadius: '9px',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.2rem',
    fontWeight: 600,
    padding: '10px 30px',
    color: theme.palette.blue.efesDarkBlue,
    cursor: 'pointer',
    minHeight: 70,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      minHeight: 84,
    },
  },
  insuranceBtn: {
    marginRight: '1rem',
    borderRadius: 9,
    minHeight: 66,
    width: '100%',
    backgroundColor: theme.palette.white.efesBackgroundLight,
  },
  medicalClaim: {
    // Here are used specific colors
    backgroundColor: '#d9f3e6',
    border: '1px solid #40C181',
    '&:hover': {
      backgroundColor: '#B2E6CB',
    },
  },
  travelClaim: {
    // Here are used specific colors
    backgroundColor: '#fff3d4',
    border: '1px solid #ffc228',
    '&:hover': {
      backgroundColor: '#FFEDBE',
    },
  },
  accidentClaim: {
    // Here are used specific colors
    backgroundColor: '#e3eae7',
    border: '1px solid #749588',
    '&:hover': {
      backgroundColor: '#d5dfdb',
    },
  },
  cascoClaim: {
    // Here are used specific colors
    backgroundColor: '#cfe5f6',
    border: `1px solid ${theme.palette.blue.efesLightBlue}`,
    '&:hover': {
      backgroundColor: '#9FCCED',
    },
  },
  claimButtonIcon: {
    width: 47,
    height: 43,
    [theme.breakpoints.down('sm')]: {
      width: 35,
      height: 30,
    },
  },
  cascoButtonIcon: {
    width: 58,
    height: 34,
    [theme.breakpoints.down('sm')]: {
      width: 46,
      height: 30,
    },
  },
  insuranceActive: {
    color: theme.palette.black.main,
    '& $insuranceText': {
      color: theme.palette.black.main,
    },
  },
  insuranceText: {
    fontSize: 16,
    fontWeight: 600,
  },
  searchBtn: {
    borderRadius: 8,
    height: 57,
    width: 73,
    bottom: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down(576)]: {
      bottom: 'unset',
      marginTop: 15,
    },
  },
  searchBtnText: {
    fontSize: '18px',
    textTransform: 'uppercase',
    color: theme.palette.white.main,
  },
  searchBtnIcon: {
    width: 28,
    height: 28,
  },
}));

export default useStyles;
